import { Alert } from '@mui/material';

import { useLocale } from '@shared/hooks/locale';

export const ListingReadOnlyAlert = () => {
  const { t } = useLocale();

  return (
    <Alert severity="info">
      {t(
        'You have read-only access to this listing. You cannot edit the brochure.',
      )}
    </Alert>
  );
};
